export const getErrMsg = (err) => {
  if (!(err instanceof Error)) {
    throw new Error('에러 객체 아님');
  }
  return err.isAxiosError ? err.response.data : err?.message ?? 'Unknown Error';
};
